// extracted by mini-css-extract-plugin
export default {"appSidebar":"AppSidebar_appSidebar__em59X"};